const accordionsHolders = document.querySelectorAll(".article-js-accordions");

if (accordionsHolders && !!accordionsHolders.length) {
  accordionsHolders.forEach((holder) => {
    const accordions = holder.querySelectorAll(".article-accordion");

    if (accordions.length > 0) {
      accordions[0].classList.add("show-text");
    }

    accordions.forEach((accordion) => {
      const accordionBtn = accordion.querySelector(
        ".article-accordion__header"
      );
      const panel = accordion.querySelector(".article-accordion__panel");

      accordionBtn.addEventListener("click", () => {
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== accordion) {
            otherAccordion.classList.remove("show-text");
            otherAccordion.querySelector(
              ".article-accordion__panel"
            ).style.maxHeight = null;
          }
        });

        accordion.classList.toggle("show-text");
        panel.style.maxHeight = accordion.classList.contains("show-text")
          ? panel.scrollHeight + "px"
          : null;
      });
    });
  });
}
